const isProduction = window.location.host === 'web.myshyft.com' || window.location.host === 'manager.myshyft.com';

const config = {
  // Base URLs
  basePricingPageUrl: isProduction 
    ? "https://www.myshyft.com/monthly_price/"
    : "https://www.myshyft.com/pricing-test-3/",
  
  baseShopPageUrl: isProduction
    ? "https://billing.stripe.com/p/login/5kAeWA49Fbv6cNi6oo"
    : "https://billing.stripe.com/p/login/test_eVa9BB6633V8eIw7ss",

  // Stripe Configuration
  stripe: {
    pricingTableId: isProduction
      ? "prctbl_1QCrEBAU4buAi3LknGKaUtMg"
      : "prctbl_1QroELAU4buAi3LkqLshmHdI", // Replace with your test pricing table ID
    publishableKey: isProduction
      ? "pk_live_KfYkH7TaFHdoyrcLzT9WZh9x"
      : "pk_test_jE339h8iz1fFxA2qbxc8rAzN", // Replace with your test publishable key
  }
};

export default config; 